/*
 * @Author: your name
 * @Date: 2020-10-26 09:18:56
 * @LastEditTime: 2021-08-14 13:21:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \admin\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/store.js'
import base from '@/plugins/base'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Public_components from '@/components/index'
import '@/assets/css/main.less';
import Moment from 'moment'
import axios from '@/plugins/axios'
import progressive from 'progressive-image/dist/vue'
Vue.use(ElementUI);
Vue.use(Public_components);
Vue.use(base);


Vue.use(progressive, {
  removePreview: true,
  scale: true
})

if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  window.location.href = `https://m.mspace.org/${location.hash}`
}


import i18n from '@/plugins/i18n'

import * as filters from '@/assets/js/filters.js';

let wallet = sessionStorage.getItem('__wallet__');
if (wallet) {
  axios.defaults.headers.common['Authorization'] = wallet;
  store.dispatch('getUserInfo')
}

Object.keys(filters).forEach(key => { //过滤器挂载在Vue上
  Vue.filter(key, filters[key])
})

let address, chainId;
//切换网络专用
// chainId = await window.CHAIN.WALLET.chainId();
// let ces = await window.CHAIN.WALLET.switchRPCSettings(97);
// console.log(ces);

function networkChangedImplement() {
  window.location.reload();
}

function accountsChangedImplement(accounts) {
  sessionStorage.setItem("__wallet__", accounts[0]);
  store.commit("SET_TOKEN", accounts[0]);
  axios.defaults.headers.common['Authorization'] = accounts[0];
  window.location.reload();
}

setTimeout(async () => {
  await window.CHAIN.WALLET.networkChangedAssign(networkChangedImplement);
  await window.CHAIN.WALLET.accountsChangedAssign(accountsChangedImplement
  );
}, 1000)


router.afterEach(async (to, from) => {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 50)
  if (store.getters.isLogin) {
    address = await window.CHAIN.WALLET.enable();
    if (address && address[0]) {
      sessionStorage.setItem("__wallet__", address[0]);
      axios.defaults.headers.common['Authorization'] = address[0];
      store.commit("SET_TOKEN", address[0]);
      store.dispatch('getUserInfo');
    }
  }

})

Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.prototype.$moment = Moment;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js